<script setup lang="ts">
import { DropdownItem } from 'vant';
import { useOfficialStyle } from './use-official-style.ts';
import { driver } from 'driver.js';
import { onMounted } from 'vue';
import 'driver.js/dist/driver.css';

const steps = [
  {
    element: '#van-dropdown-menu-3-1',
    popover: {
      title: '',
      description: '选择大品类'
    }
  },
  {
    element: `#van-dropdown-menu-3-2`,
    popover: {
      title: '',
      description: '选择中品类'
    }
  },
  {
    element: `#van-dropdown-menu-3-3`,
    popover: {
      title: '',
      description: '选择小品类'
    }
  }
];

const handleDriverIntro = () => {
  driver({
    nextBtnText: '下一个',
    prevBtnText: '上一个',
    doneBtnText: '完成',
    showProgress: true,
    steps: steps
  }).drive();
  localStorage.setItem('intro-cloud', `${Date.now()}`);
};

onMounted(() => {
  const intro = localStorage.getItem('intro-cloud');
  if (!intro) {
    handleDriverIntro();
  }
});

const { type1, type2, type3, onFilterChange, type1Options, type2Options, type3Options } = useOfficialStyle();

</script>

<template>
  <DropdownItem :model-value="type1" :options="type1Options" @change="onFilterChange('type1',$event)" />
  <DropdownItem :model-value="type2" :options="type2Options" @change="onFilterChange('type2',$event)" />
  <DropdownItem :model-value="type3" :options="type3Options" @change="onFilterChange('type3',$event)" />
</template>

<style scoped>

</style>
